// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function UmbrellaIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M30 15.829a14.055 14.055 0 0 0-23.531-9.11 13.945 13.945 0 0 0-4.463 9.11A2 2 0 0 0 4 18h11v7a4 4 0 1 0 8 0 1 1 0 0 0-2 0 2 2 0 0 1-4 0v-7h11a2 2 0 0 0 2-2.171ZM4 16a12.019 12.019 0 0 1 9.525-10.736C12.06 7.25 10.231 10.764 10.021 16H4Zm8.019 0c.174-3.846 1.316-6.601 2.287-8.28A13.302 13.302 0 0 1 16 5.395a13.29 13.29 0 0 1 1.69 2.325c1.66 2.868 2.185 5.94 2.287 8.28H12.02Zm9.956 0c-.21-5.236-2.039-8.75-3.5-10.742A12.009 12.009 0 0 1 28 16h-6.025Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
